export const CREDIT_APPLICATION_PAGE_MAX_WIDTH = 600;
